import { X } from 'lucide-react'

interface DeleteAgentModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    agentName: string
    isDeleting?: boolean
}

export function DeleteAgentModal({ isOpen, onClose, onConfirm, agentName, isDeleting = false }: DeleteAgentModalProps) {
    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl max-w-md w-full p-6 border border-gray-200 dark:border-gray-700">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-bold text-gray-900 dark:text-white">
                        Deletar Agente
                    </h2>
                    <button
                        onClick={onClose}
                        className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                        disabled={isDeleting}
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                {/* Warning Message */}
                <div className="mb-6">
                    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-4">
                        <p className="text-sm text-red-800 dark:text-red-200">
                            ⚠️ Esta ação não pode ser desfeita!
                        </p>
                    </div>
                    <p className="text-gray-700 dark:text-gray-300 mb-2">
                        Tem certeza que deseja deletar o agente:
                    </p>
                    <p className="text-lg font-semibold text-gray-900 dark:text-white">
                        {agentName}
                    </p>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                        Todos os arquivos e configurações deste agente serão permanentemente removidos.
                    </p>
                </div>

                {/* Actions */}
                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg font-semibold hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                        disabled={isDeleting}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={isDeleting}
                    >
                        {isDeleting ? 'Deletando...' : 'Deletar'}
                    </button>
                </div>
            </div>
        </div>
    )
}
